// Page-wide drill-down filters. A filter is a breakdown row key ("route:3",
// "salesman:unassigned", "customer:12", "account:40") that the API accepts as
// a repeated `filter` query parameter.

export const DRILL_DIMENSIONS = {
  route: { label: "Route", itemLevel: true },
  customer: { label: "Customer", itemLevel: false },
  vendor: { label: "Vendor", itemLevel: true },
  product_category: { label: "Category", itemLevel: true },
  product: { label: "Product", itemLevel: true },
  account_type: { label: "Account type", itemLevel: false },
  salesman: { label: "Salesman / office", itemLevel: false },
};

export function dimensionOfKey(key) {
  if (typeof key !== "string") return null;
  const prefix = key.split(":")[0];
  if (prefix === "account") return "customer";
  return DRILL_DIMENSIONS[prefix] ? prefix : null;
}

export function canDrill(row) {
  return Boolean(row && row.key && row.key !== "adjustment" && dimensionOfKey(row.key));
}

// Adds a filter, replacing any existing filter on the same dimension.
export function addDrillFilter(filters, row) {
  if (!canDrill(row)) return filters;
  const dimension = dimensionOfKey(row.key);
  return [
    ...filters.filter((filter) => filter.dimension !== dimension),
    { key: row.key, dimension, name: row.name || "Unassigned" },
  ];
}

export function hasItemLevelFilter(filters) {
  return filters.some((filter) => DRILL_DIMENSIONS[filter.dimension]?.itemLevel);
}
